<template>
  <div class="swiper-card card-debug">
    <transition-group
      name="fade-slide-bottom"
      tag="div"
      v-if="reveal"
      class="reveal-group"
      appear
    >
      <h3 :key="'title-wrapper'">Detox day: {{ getOBxDetoxDay }}</h3>

      <p :key="'byline-wrapper'">
        {{ iDaysRemain | abs }} days of detox to go!
      </p>

      <div :key="`buttons`">
        <ul class="day-buttons">
          <li>
            <button @click.prevent="doReset('time')">Reset (time)</button>
          </li>
          <li>
            <button @click.prevent="doReset('topics')">Reset (topic)</button>
          </li>
          <li>
            <button @click.prevent="doReset('locales')">Reset (locale)</button>
          </li>
          <li>
            <button @click.prevent="doAdvance(0.5)">+½ day</button>
          </li>
          <li>
            <button @click.prevent="doAdvance(1)">+1 day</button>
          </li>
          <!-- <li v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8]" :key="`day-${i}`">
            <button>{{ i }}</button>
          </li> -->
        </ul>
      </div>

      <p :key="`meta`" class="small">
        Total days: {{ getOBxTotalDays }}, 
        Past step: {{ getOBxDaysPastStep }}, 
        Total steps {{ getOBxTotalSteps }}, 
        Detox day: {{ getOBxDetoxDay }}, 
        Pic available: {{ getOBxPickAvailable }}, 
        Content: {{ getOBxPickContent.title }} // {{ getOBxPickContent.body }}
      </p>

      <div :key="`cards`" class="cards">
        <h3>Activities</h3>
        <div class="buttons">
          <button @click="review()">Rating</button>
          <button @click="homeReset()">Home:Reset</button>
          <!-- <button @click="testPushPayload()">Push Payload Test</button> -->
        </div>
      </div>

      <div :key="`cards`" class="cards">
        <h3>Cards</h3>
        <div class="buttons">
          <button @click="ringProgressDial()">Ring Complete</button>
          <button @click="ringProgressComplete()">Dial Complete</button>
          <button @click="xpAchieved()">XP Achieved</button>
          <button @click="streakAchieved()">Streak Extended</button>
          <button @click="inviteAccepted()">Invite Accepted</button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        reveal: true
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {

    },

    computed: {
      // transfer from coaching..
      // computeds
      iDaysRemain() {
        return this.$coachingEngine.iDaysRemain;
      },
      // methods
      getOBxTotalDays() { 
        return this.$coachingEngine.getOBxTotalDays();
      },
      getOBxDaysPastStep() { 
        return this.$coachingEngine.getOBxDaysPastStep();
      },
      getOBxTotalSteps() { 
        return this.$coachingEngine.getOBxTotalSteps();
      },
      getOBxDetoxDay() { 
        return this.$coachingEngine.getOBxDetoxDay();
      },
      getOBxPickAvailable() { 
        return this.$coachingEngine.getOBxPickAvailable();
      },
      getOBxPickContent() { 
        return this.$coachingEngine.getOBxPickContent();
      },
    },

    mounted () {
      setTimeout(() => {
        this.$emit('swiperUpdate')
      }, 100)
    },

    methods: {
      doReset(sFocus = 'time') {
        // @jason -- please improve the button setup to allow the focus and media values to be editable -- ** particularly ** `time` vs `locales`, `topics` -- (`media` is less important - that's just copy influence)
        this.$coachingEngine.doOBxResetFull(sFocus, 'social');
        this.EventBus.$emit('home:reset', 'Debug');
        this.EventBus.$emit('swiper:close');
      },
      doAdvance(iDays = 1) {
        this.$coachingEngine.doOBxAdvanceDays(iDays);
        this.EventBus.$emit('home:reset', 'Debug');
        this.EventBus.$emit('swiper:close');
      },

      /**
       *  ACTIVITES
       */


      homeReset() {
        this.EventBus.$emit('home:reset', 'Debug');
      },

      review() {
        this.EventBus.$emit('layer:new', {
          component: 'app-review',
        });
      },

      testPushPayload() {
        console.log(`Foo`);
        this.EventBus.$emit("push:tap", {
          // feature: ":five-a-day",
          edition: "p1xicfboyzxihf6j",
          url: "/n/five-a-day",
          source: "Testing",
          campaign: "Testing",
          beacon: "6993-jp3en0v9s8ig1kak"
        });
        console.log(`Bar`);
      },





      /**
       *  CARDS
       */

      ringProgressDial() {
        this.EventBus.$emit('layer:new', {
          component: 'ring-progress',
          opts: {
            focus: 'locales',
            heading: `Great work!`,
            paragraph: `You've completed the Topic ring! Now it's time to wrap up your Time and Countries rings to complete your day.`
          }
        });
      },

      ringProgressComplete() {
        this.EventBus.$emit('layer:new', {
          component: 'ring-progress',
          opts: {
            heading: `That's a wrap!`,
            paragraph: `You're done for the day. Explore news that interests you or switch off and take a break. `
          }
        });
      },

      xpAchieved() {
        this.EventBus.$emit('layer:new', {
          component: 'experience',
          opts: {
            count: 20,
            reason: `Nicely done! You've earned 500 XP for completing your Five-A-Day!`
          }
        });
      },

      inviteAccepted() {
        this.EventBus.$emit('layer:new', {
          component: 'invite-accepted',
          opts: {
            name: 'Jim',
          }
        });
      },

      streakAchieved() {
        this.EventBus.$emit('layer:new', {
          component: 'streak-achieved',
          opts: {
            days: 7,
            message: `You're on fire! Keep up the great work and continue your streak!`
          }
        });
      },







    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-debug {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    text-align: center;
    height: 100%;

    .lottie {
      margin-bottom: -4rem;
    }

    h3 {
      font-family: 'Circular';
      font-weight: bold;
      font-size: 1.75rem;
      margin: 0 0 0.5rem 0;
    }

    p {
      font-family: 'Circular';
      font-size: 1.1rem;

      &.small {
        font-size: 0.9rem;
      }
    }

    button {
      margin-top: 2rem;
      height: 55px;
      border-radius: 10px;
      font-size: 1rem;
      padding-top: 0.8rem;
    }


    .day-buttons {
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
      flex-direction: row;
      gap: 1em;
      margin-bottom: 1em;
    }
  }

  .cards {
    margin-top: 2rem;

    h3 {
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }

    .buttons {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;

      button {
        margin-top: 0;
      }
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>